// "Duami" as it appears in the app and on the icon: "Du" in ink, "ami" in
// red, on one line. Size and tracking come from the className (wordmark,
// wordmark-sm) or the style passed in. The ™ marks it as an unregistered
// trade mark; only switch to ® once the name is registered.
export function Wordmark({ className = "wordmark", style }) {
  return (
    <div className={className} style={style} role="img" aria-label="Duami">
      <span aria-hidden="true">Du</span>
      <span className="wm-ami" aria-hidden="true">ami</span>
      <span className="wm-tm" aria-hidden="true">™</span>
    </div>
  );
}
